import { createFileRoute, Link } from "@tanstack/react-router";

import { PageHero, CtaBand } from "@/components/page-parts";
import { BLOG_POSTS, isDraftPost, publishedPosts } from "@/lib/blog";

const URL = "https://coastsidelaw.com.au/blog";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "Local Property & Wills Blog | Coastside Law" },
      {
        name: "description",
        content:
          "Short, practical posts on conveyancing, wills and probate for Caloundra, Golden Beach and the Redcliffe Peninsula, from Coastside Law's solicitors.",
      },
      { property: "og:title", content: "Coastside Law blog: local conveyancing, wills and probate tips" },
      {
        property: "og:description",
        content: "Practical tips for buyers, sellers, will-makers and executors on the Sunshine Coast and Redcliffe Peninsula.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
      // Kept out of search until at least one post is approved.
      ...(publishedPosts().length === 0 ? [{ name: "robots", content: "noindex" }] : []),
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: BlogIndex,
});

function BlogIndex() {
  return (
    <>
      <PageHero
        eyebrow="Blog"
        title="Local tips on property, wills and probate"
        lead="Short, practical posts for buyers, sellers, will-makers and executors around Caloundra, Golden Beach and the Redcliffe Peninsula."
      />
      <section className="mx-auto max-w-3xl px-5 py-14">
        <ul className="divide-y divide-border border-y border-border">
          {BLOG_POSTS.map((p) => (
            <li key={p.slug} className="py-6">
              <p className="text-xs font-semibold uppercase tracking-[0.15em] text-muted-foreground">
                {p.category} · {p.area}
                {isDraftPost(p.slug) && " · Draft"}
              </p>
              <h2 className="mt-2 font-serif text-2xl leading-snug text-foreground">
                <Link to="/blog/$slug" params={{ slug: p.slug }} className="hover:underline">
                  {p.title}
                </Link>
              </h2>
              <p className="mt-2 text-sm leading-7 text-muted-foreground">{p.description}</p>
            </li>
          ))}
        </ul>
      </section>
      <CtaBand />
    </>
  );
}
